const _ROUTERS = {
	_HOME:'/',
	_COMBAT:"/combat",
	_PERSONALITY:"/personality",
	_Mint:"/mint",
	_Story:"/story"
};

export default _ROUTERS;
